import React from 'react';


import { WidgetProps } from '@rjsf/core';
import { Form, Checkbox, List, CheckboxProps } from 'semantic-ui-react'
import { useSchemaTranslation } from '../../../useSchemaTranslation';

const selectValue = (value: any, selected: any, all: any) => {
  const at = all.indexOf(value);
  const updated = selected.slice(0, at).concat(value, selected.slice(at));

  // As inserting values at predefined index positions doesn't work with empty
  // arrays, we need to reorder the updated selection to match the initial order
  return updated.sort((a: any, b: any) => all.indexOf(a) > all.indexOf(b));
};

const deselectValue = (value: any, selected: any) => {
  return selected.filter((v: any) => v !== value);
};

const CheckboxesWidget = ({
  schema,
  label,
  id,
  disabled,
  options,
  value = [],
  autofocus,
  readonly,
  required,
  onChange,
  onBlur,
  onFocus,
}: WidgetProps) => {
  let { enumOptions, enumDisabled } = options;

  const { t } = useSchemaTranslation();

  const inline = Boolean(options.inline);


  const _onChange = (option: any): CheckboxProps["onChange"] => (_1, { checked }) => {
    const all = (enumOptions as any).map(({ value }: any) => value);
    if (checked) {
      onChange(selectValue(option.value, value, all));
    } else {
      onChange(deselectValue(option.value, value));
    }
  };

  const _onBlur = ({ target: { value }, }: React.FocusEvent<HTMLButtonElement>) => onBlur(id, value);
  const _onFocus = ({ target: { value }, }: React.FocusEvent<HTMLButtonElement>) => onFocus(id, value);


  if (readonly) {
    enumOptions = (enumOptions as any).filter((option: any) => value === option.value)
    return (
      <List className="field-checkboxes" inline={String(inline)}>
        {(enumOptions as any).map((option: any, index: number) => (
          <List.Item key={index} id={`${id}_${index}`} >
            {t(option.label)}
          </List.Item>
        ))}
      </List>
    )
  }

  return (
    <Form.Group
      id={id}
      className="field-checkboxes"
      required={required}
      inline={Boolean(inline)}
      grouped={!inline}
    >
      {(enumOptions as any).map((option: any, index: number) => {
        const checked = Array.isArray(value) ? value.includes(option.value) : value === option.value
        const itemDisabled =
          enumDisabled && (enumDisabled as any).indexOf(option.value) != -1; // eslint-disable-line

        return (
          <Form.Field
            key={index}
            id={`${id}_${index}`}
            checked={checked}
            //disabled={disabled || itemDisabled || readonly}
            disabled={disabled || Boolean(itemDisabled)}
            autoFocus={autofocus && index === 0}
            onChange={_onChange(option)}
            onBlur={_onBlur}
            onFocus={_onFocus}
            control={Checkbox}
            label={t(option.label)}
          />

        );
      })}


    </Form.Group>


  );
};

export default CheckboxesWidget;
